import { render, staticRenderFns } from "./EVMBlockSummary.vue?vue&type=template&id=11ff9080&scoped=true&"
import script from "./EVMBlockSummary.vue?vue&type=script&lang=ts&"
export * from "./EVMBlockSummary.vue?vue&type=script&lang=ts&"
import style0 from "./EVMBlockSummary.vue?vue&type=style&index=0&id=11ff9080&scoped=true&lang=scss&"
import style1 from "./EVMBlockSummary.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ff9080",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTab,VTabItem,VTabs,VTooltip})
